var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showSignatureCard)?_c('card',[_c('call-for-action',{attrs:{"vertical":!_vm.compact,"reduce-text":false,"reduce-button":false,"action":_vm.$t('dashboard.mark-as-read'),"loading":_vm.signing,"handler":_vm.sign}},[_vm._v("\n        "+_vm._s(_vm.$t('dashboard.mark-as-read-notice'))+"\n    ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }